import Table from '../../site-table/custom-table/table/Table';
import { CLEAR_COLLAPSED_GROUPS, SET_ALL_GROUPS_COLLAPSED } from '../../site-table/table.ui.store';
import Timeline from '../../site-timeline/Timeline';

export function bulkUngroup(groupedObject: Timeline | Table): void {
  SET_ALL_GROUPS_COLLAPSED(false);
  CLEAR_COLLAPSED_GROUPS();

  if (groupedObject instanceof Timeline) {
    (groupedObject as Timeline).sortTimeline();
  } else {
    (groupedObject as Table).sortTable();
  }
}
